import axios, { AxiosResponse } from 'axios';
import { UpdateFeedStrategyInput } from 'views/profiles-strategies/features/feed-strategies/types/update-feed-strategy-input.type';

//TODO a lot of feed strategy endpoints are shared in planning and prognosis. make shared CRUD folder and import them into subfeature's CRUD folder?

// PUT
// /ewosapi/v2/planandprognosis/feedstrategy/{feedStrategyId}
// Updates feed strategy in SeaCloud
export const putFeedStrategy = async (feedStrategyId: number, request: UpdateFeedStrategyInput): Promise<AxiosResponse> => {
  return await axios.put(`/ewosapi/v2/planandprognosis/feedstrategy/${feedStrategyId}`, request);
};
